import {Routes} from '@angular/router';
import { HomeComponent } from './pages/home/components/home/home.component';
import { LoginComponent } from './pages/home/components/login/login.component';
import { DashboardComponent } from './pages/home/components/dashboard/dashboard.component';
import { RecuperarClaveComponent } from './pages/home/components/recuperar-clave/recuperar-clave.component';
import { CambioClaveComponent } from './pages/home/components/cambio-clave/cambio-clave.component';
import { AuthGuard } from './guards/auth-guard';
import { LoginSifirmaComponent } from './pages/login/components/login-sifirma/login-sifirma.component';
import { LoginCasillaComponent } from './pages/login/components/login-casilla/login-casilla.component';
import { LoginSneComponent } from './pages/login/components/login-sne/login-sne.component';
import { LoginSigoComponent } from './pages/login/components/login-sigo/login-sigo.component';
// import { SearchComponent } from './components/search/search.component';

export const ROUTES: Routes = [
    { path: '', component: DashboardComponent },
    { path: 'loginPortal', component: LoginComponent },
    { path: 'loginSifirma', component: LoginSifirmaComponent },
    { path: 'loginSigo', component: LoginSigoComponent },
    // { path: 'loginSifirma/:id', component: LoginSifirmaComponent },
    { path: 'loginCasilla', component: LoginCasillaComponent },
    { path: 'loginSne', component: LoginSneComponent },
    { path: 'home', component: HomeComponent /*, canActivate: [AuthGuard]*/ },
    { path: 'dashboard', component: DashboardComponent/*, canActivate: [AuthGuard] */},
    { path: 'recuperar-clave', component: RecuperarClaveComponent/*, canActivate: [AuthGuard]*/ },    
    { path: 'cambio-clave', component: CambioClaveComponent/*, canActivate: [AuthGuard]*/ },    
    { path: '**', pathMatch: 'full', redirectTo: ''}
]; 